import script from "./OneVrHomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./OneVrHomeView.vue?vue&type=script&setup=true&lang=js"

import "./OneVrHomeView.vue?vue&type=style&index=0&id=002ffb40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002ffb40"]])

export default __exports__